/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Simplified)
export default {
  'ai-mate.chat-error-banner.description': '聊天记录最长可以保存 30 天。',
  'ai-mate.chat-error-banner.title': '开启新聊天',
  'ai-mate.chat-error.description': '请尝试<btn>重新加载聊天</btn>。',
  'ai-mate.chat-error.rate-limited-description': '您的请求数量已达到上限。请稍后重试。',
  'ai-mate.chat-error.rate-limited-title': '请求过多',
  'ai-mate.chat-error.rovo-inactive-description': '您的站点上似乎未启用 Rovo。<link>设置 Rovo</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo 处于非活动状态',
  'ai-mate.chat-error.title': '无法确定出现了什么问题',
  'conversation-assistant-button.label': '聊天',
  'conversation-assistant-button.rovo-chat-label': 'Rovo 聊天',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': '向 Atlassian Intelligence 询问此问题',
  'highlight-actions.rovo-chat-explain-option.text': '解释',
  'highlight-actions.rovo-chat-explain-prompt': '解释此内容：{selectedText}',
  'highlight-actions.rovo-chat-more-options.tooltip': '聊天建议',
  'highlight-actions.rovo-chat-open-chat.tooltip': '打开聊天',
  'highlight-actions.rovo-chat-summarize-option.text': '生成摘要',
  'highlight-actions.rovo-chat-summarize-prompt': '为以下内容生成摘要：{selectedText}',
  'highlight-actions.rovo-chat.button-text': '聊天',
  'horizontal-scroll-container.scroll-left': '向左滚动',
  'horizontal-scroll-container.scroll-right': '向右滚动',
};
